import { render } from "./image-container.vue?vue&type=template&id=55e14836&scoped=true&ts=true"
import script from "./image-container.vue?vue&type=script&lang=ts"
export * from "./image-container.vue?vue&type=script&lang=ts"

import "./image-container.vue?vue&type=style&index=0&id=55e14836&scoped=true&lang=scss"

import exportComponent from "/Users/reevoengineering/Projects/reevo/propbank/propbank-brochure-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e14836"]])

export default __exports__